const STATIC_URL =
  process.env.NODE_ENV === "development"
    ? "/assets/"
    : `${process.env.PUBLIC_URL}/static/`;

export function getImage(imageName) {
  const imagePath = `${STATIC_URL}img/${imageName}`;
  return imagePath;
}
